// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3v96f","content":"styles_content__2TiOT","checkbox":"styles_checkbox__3jGN-","checkboxLabel":"styles_checkboxLabel__xfvao"};